import { useAuth } from '../contexts/AuthContext';

export const useUserPermissions = (permission: string) => {
  const { userPermissions } = useAuth();

  return userPermissions.some(userPermission => userPermission.name === permission);
};
